import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { SaleDocket } from '../../models/sale-docket';
import { Observable } from 'rxjs';

@Injectable()
export class SaleDocketService {
  private resourceEndpoint = 'sale-dockets';

  constructor(private http: ApiClient) {}

  public getAll() {
    return this.http.get<SaleDocket[]>(this.resourceEndpoint);
  }

  public getSaleDocket(id: number) {
    return this.http.get<SaleDocket>(`${this.resourceEndpoint}/${id}`);
  }

  public addSaleDocket(docket: Partial<SaleDocket>) {
    return this.http.post<SaleDocket>(`${this.resourceEndpoint}`, docket);
  }

  public updateSaleDocket(id: number, docket: Partial<SaleDocket>) {
    return this.http.put<SaleDocket>(`${this.resourceEndpoint}/${id}`, docket);
  }

  finalizeSaleDocket(id): Observable<void> {
    return this.http.put<void>(`${this.resourceEndpoint}/${id}/finalize`, {});
  }

  print(id) {
    return this.http.getResponse(`${this.resourceEndpoint}/${id}/print`);
  }
}
